import { useTranslation } from 'react-i18next';

const stats = [
  { value: 'value1', label: 'label1' },
  { value: 'value2', label: 'label2' },
  { value: 'value3', label: 'label3' },
  { value: 'value4', label: 'label4' },
];

export default function Stats() {
  const { t } = useTranslation();

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold uppercase tracking-wide">
            {t('stats.tag')}
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            {t('stats.title')}
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-sm md:text-base text-foreground-600">
            {t('stats.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s) => (
            <div
              key={s.value}
              className="rounded-lg border border-background-200 bg-white p-6 md:p-8 text-center"
            >
              <div className="font-heading font-extrabold text-3xl md:text-4xl text-primary-600">
                {t(`stats.${s.value}`)}
              </div>
              <div className="mt-2 text-xs md:text-sm text-foreground-600">
                {t(`stats.${s.label}`)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}